<template>
  <va-edit-layout>
    <departments-form :id="id" :title="title" :item="item"></departments-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
